// @generated by protoc-gen-es v1.7.2
// @generated from file penumbra/core/app/v1/app.proto (package penumbra.core.app.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Transaction } from "../../transaction/v1/transaction_pb.js";
import { GenesisContent as GenesisContent$5, SctParameters } from "../../component/sct/v1/sct_pb.js";
import { CommunityPoolParameters, GenesisContent as GenesisContent$6 } from "../../component/community_pool/v1/community_pool_pb.js";
import { GenesisContent as GenesisContent$3, GovernanceParameters } from "../../component/governance/v1/governance_pb.js";
import { GenesisContent as GenesisContent$4, IbcParameters } from "../../component/ibc/v1/ibc_pb.js";
import { GenesisContent as GenesisContent$1, StakeParameters } from "../../component/stake/v1/stake_pb.js";
import { FeeParameters, GenesisContent as GenesisContent$7 } from "../../component/fee/v1/fee_pb.js";
import { DistributionsParameters, GenesisContent as GenesisContent$8 } from "../../component/distributions/v1/distributions_pb.js";
import { FundingParameters, GenesisContent as GenesisContent$9 } from "../../component/funding/v1/funding_pb.js";
import { GenesisContent as GenesisContent$2, ShieldedPoolParameters } from "../../component/shielded_pool/v1/shielded_pool_pb.js";
import { DexParameters, GenesisContent as GenesisContent$10 } from "../../component/dex/v1/dex_pb.js";
import { AuctionParameters, GenesisContent as GenesisContent$11 } from "../../component/auction/v1/auction_pb.js";

/**
 * Requests the list of all transactions that occurred within a given block.
 *
 * @generated from message penumbra.core.app.v1.TransactionsByHeightRequest
 */
export const TransactionsByHeightRequest = proto3.makeMessageType(
  "penumbra.core.app.v1.TransactionsByHeightRequest",
  () => [
    { no: 2, name: "block_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * A transaction that appeared within a given block.
 *
 * @generated from message penumbra.core.app.v1.TransactionsByHeightResponse
 */
export const TransactionsByHeightResponse = proto3.makeMessageType(
  "penumbra.core.app.v1.TransactionsByHeightResponse",
  () => [
    { no: 1, name: "transactions", kind: "message", T: Transaction, repeated: true },
    { no: 2, name: "block_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.app.v1.AppParameters
 */
export const AppParameters = proto3.makeMessageType(
  "penumbra.core.app.v1.AppParameters",
  () => [
    { no: 1, name: "chain_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sct_params", kind: "message", T: SctParameters },
    { no: 3, name: "community_pool_params", kind: "message", T: CommunityPoolParameters },
    { no: 4, name: "governance_params", kind: "message", T: GovernanceParameters },
    { no: 5, name: "ibc_params", kind: "message", T: IbcParameters },
    { no: 6, name: "stake_params", kind: "message", T: StakeParameters },
    { no: 7, name: "fee_params", kind: "message", T: FeeParameters },
    { no: 8, name: "distributions_params", kind: "message", T: DistributionsParameters },
    { no: 9, name: "funding_params", kind: "message", T: FundingParameters },
    { no: 10, name: "shielded_pool_params", kind: "message", T: ShieldedPoolParameters },
    { no: 11, name: "dex_params", kind: "message", T: DexParameters },
    { no: 12, name: "auction_params", kind: "message", T: AuctionParameters },
  ],
);

/**
 * Requests the global configuration data for the app.
 *
 * @generated from message penumbra.core.app.v1.AppParametersRequest
 */
export const AppParametersRequest = proto3.makeMessageType(
  "penumbra.core.app.v1.AppParametersRequest",
  [],
);

/**
 * @generated from message penumbra.core.app.v1.AppParametersResponse
 */
export const AppParametersResponse = proto3.makeMessageType(
  "penumbra.core.app.v1.AppParametersResponse",
  () => [
    { no: 1, name: "app_parameters", kind: "message", T: AppParameters },
  ],
);

/**
 * @generated from message penumbra.core.app.v1.GenesisAppState
 */
export const GenesisAppState = proto3.makeMessageType(
  "penumbra.core.app.v1.GenesisAppState",
  () => [
    { no: 1, name: "genesis_content", kind: "message", T: GenesisContent, oneof: "genesis_app_state" },
    { no: 2, name: "genesis_checkpoint", kind: "scalar", T: 12 /* ScalarType.BYTES */, oneof: "genesis_app_state" },
  ],
);

/**
 * @generated from message penumbra.core.app.v1.GenesisContent
 */
export const GenesisContent = proto3.makeMessageType(
  "penumbra.core.app.v1.GenesisContent",
  () => [
    { no: 1, name: "chain_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stake_content", kind: "message", T: GenesisContent$1 },
    { no: 3, name: "shielded_pool_content", kind: "message", T: GenesisContent$2 },
    { no: 4, name: "governance_content", kind: "message", T: GenesisContent$3 },
    { no: 5, name: "ibc_content", kind: "message", T: GenesisContent$4 },
    { no: 6, name: "sct_content", kind: "message", T: GenesisContent$5 },
    { no: 7, name: "community_pool_content", kind: "message", T: GenesisContent$6 },
    { no: 8, name: "fee_content", kind: "message", T: GenesisContent$7 },
    { no: 9, name: "distributions_content", kind: "message", T: GenesisContent$8 },
    { no: 10, name: "funding_content", kind: "message", T: GenesisContent$9 },
    { no: 11, name: "dex_content", kind: "message", T: GenesisContent$10 },
    { no: 12, name: "auction_content", kind: "message", T: GenesisContent$11 },
  ],
);

